import React, { Component } from 'react';
import styled from 'styled-components';

// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';

// Custom components
import CompanyInterfaceForm, { ComponentWrapper, FormWrapper, FormRowWrapper, FormColumnWrapper, TopContainer, LinkWrapper } from 'containers/CompanyContainer/CompanyInterfaceForm';
import FormImageInput from 'containers/CompanyContainer/Forms/Components/FormImageInput';
import FormTextField from 'containers/CompanyContainer/Forms/Components/FormTextField';
import FormTextArea from 'containers/CompanyContainer/Forms/Components/FormTextArea';
import FormSectionTitle from 'containers/CompanyContainer/Forms/Components/FormSectionTitle';
import CompanyPageTitle from 'containers/CompanyContainer/CompanyPageTitle';
import CompanyPageButton from 'containers/CompanyContainer/CompanyPageButton';
import LoaderWrapper from 'containers/CompanyContainer/LoaderWrapper';

// Constants
import { constants } from 'constants/index';

export const ExtraFieldsWrapper = styled.div`
    display: flex;
    margin-top: 30px;
`;
export const FormSectionWrapper = styled.div`
    width: 50%;
`;
class CompanySetupForm extends CompanyInterfaceForm {

    state = {
        companyLogo: null,
        name: '',
        description: '',
        street: '',
        city: '',
        province: '',
        postalCode: '',
        country: '',
        formValidationErrors: {},
        loadingData: false
    }

    componentDidMount() {
        const { companyInfo } = this.props;
        const companyExist = companyInfo => companyInfo ? true : false;

        if(companyExist(companyInfo)){
            const formattedCompanyData = {};
            const { state } = this;
            const companyValues = {
                ...companyInfo,
                ...companyInfo.address,
            };

            const setItemValues = valueKey => formattedCompanyData[valueKey] = companyValues[valueKey] || null;

            Object.keys(state).forEach(setItemValues)
            this.setState(formattedCompanyData);
        }
    }


    getTopContainerActions = () => {
        const { companyInfo } = this.props;
        const companyExist = companyInfo => companyInfo ? true : false;
        return(
            <React.Fragment>
                <CompanyPageButton
                    test-label="saveButton"
                    type={'dark'}
                    size={'small'}
                    children={'Save'}
                />
                {companyExist(companyInfo) &&
                    <LinkWrapper
                        to='/company/dashboard'
                    >
                        Back to Dashboard >
                    </LinkWrapper>
                }
            </React.Fragment>
        );
    }

    checkValidation = ({event, type}) => {
        const { name, value } = event.target;
        const errorMessage = this.validateInput({
            type,
            value: event.target.value
        });
        let formValidationErrors = {...this.state.formValidationErrors};
        formValidationErrors[name] = errorMessage;

        this.setState({formValidationErrors})
    }

    getFormFields = () => {
        return (
            <React.Fragment>
                <FormRowWrapper>
                    <FormColumnWrapper>
                        {this.getCompanyDescriptionFields()}
                    </FormColumnWrapper>
                    <FormColumnWrapper>
                        {this.getCompanyAddressFields()}
                    </FormColumnWrapper>
                </FormRowWrapper>
            </React.Fragment>
        );
    }

    formatDataForDB = (e) => {
        e.preventDefault();

        const {
            companyLogo,
            name,
            description,
            street,
            city,
            province,
            postalCode,
            country
        } = this.state;

        const companyData = {
            companyLogo,
            name,
            description,
            address:{
                street,
                city,
                province,
                postalCode,
                country
            }
        };

        const { userData } = this.props;
        userData.providerCompany
            ? this.props.updateCompanyInfo({
                companyInfo: companyData,
                companyId: userData.providerCompany
            }).then( success =>
                success
                    ? this.props.history.push('/company/dashboard')
                    : console.log('reset')
            )
            : this.setupCompany(companyData)
    }

    setupCompany = (companyData) => {
        const {
            formattedProviderData,
            formattedUserData,
            authData
        } = this.props;

        this.props.createCompany({
            companyInfo: companyData,
            formattedProviderData,
            formattedUserData,
            user: authData
        })
        .then( success =>
            success
            ? console.log('success')
            : console.log('reset')
        );
        this.setState({ loadingData: true})
    }

    render () {
        const { getTopContainerActions, getFormFields, formatDataForDB } = this;
        const { formattedUserData, companyInfo, userData } = this.props;
        const { loadingData } = this.state;

        let loader = null;
        if(loadingData){
            companyInfo && this.props.history.push('/company/dashboard');
            loader = <LoaderWrapper/>;
        }
        (!formattedUserData && !companyInfo) && this.props.history.push('/company/adminSetup');
        return (
            <ComponentWrapper >
                { loader }
                <FormWrapper onSubmit={formatDataForDB}>
                    <TopContainer>
                        {getTopContainerActions()}
                    </TopContainer>
                    {getFormFields()}
                </FormWrapper>
            </ComponentWrapper>
        )
    }
}

//export default CompanySetupForm;

const mapStateToProps = ({auth, company, router, client}) => ({
    companyInfo: company.companyInfo,
    services: company.services,
    authData: auth.authData,
    location: router.location,
    userData: client.clientData,
    formattedProviderData: company.formattedProviderData,
    formattedUserData: company.formattedUserData
});

export default connect(mapStateToProps,actions)(CompanySetupForm);




// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/CompanySetupForm.jsx